import { Navigate, Outlet } from 'react-router';
import { useSession } from '@/features/auth';
import { useAppAbility } from '@/features/auth';
import AppLoadingScreen from '@/shared/ui/AppLoadingScreen';

// Guardia di rotta: `<RequireAbility I="read" a="User" />` con le rotte figlie.
const RequireAbility = ({ I: action, a: subjectType }) => {
  const { user, loading } = useSession();
  const ability = useAppAbility();

  if (loading) {
    return <AppLoadingScreen message="Verifica permessi…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!ability.can(action, subjectType)) {
    return <Navigate to="/operations" replace />;
  }

  return <Outlet />;
};

export default RequireAbility;
